import { callbacks, setCallback } from './callbacks';
import { app } from './appEnvironment';

const askMeForShareScreen = (successCallback, errorCallback, canceledCallback) => {
    setCallback("afterShareScreenDidFinishSuccess", successCallback);
    setCallback("afterShareScreenDidFinishFail", errorCallback);
    setCallback("afterShareScreenDidCancel", canceledCallback);
    app.callFunction("askMeForShareScreen");
}

const shareScreenDidFinishSuccess = () => {
    callbacks.afterShareScreenDidFinishSuccess();
}

const shareScreenDidFinishFail = () => {
    callbacks.afterShareScreenDidFinishFail();
}

const shareScreenDidCancel = () => {
    callbacks.afterShareScreenDidCancel();
}

const startShareImage = (data) => {
    app.callFunction("startShareImage", data);
}

const startShareText = (data) => {
    app.callFunction("startShareText", data);
}

const initShare = () => {
    window.shareScreenDidFinishSuccess = shareScreenDidFinishSuccess;
    window.shareScreenDidFinishFail = shareScreenDidFinishFail;
    window.shareScreenDidCancel = shareScreenDidCancel;
}

export { askMeForShareScreen, startShareImage, startShareText, initShare };